var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.3828 0 0 5.3828 0 12C0 18.6172 5.3828 24 12 24C18.6172 24 24 18.6163 24 12C24 5.38373 18.6172 0 12 0ZM12 22.141C6.40898 22.141 1.85902 17.592 1.85902 12C1.85902 6.40805 6.40898 1.85902 12 1.85902C17.591 1.85902 22.141 6.40805 22.141 12C22.141 17.592 17.592 22.141 12 22.141Z",
    fill: "#334785"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6465 10.9855H12.9285V7.26742C12.9285 6.75433 12.513 6.33789 11.999 6.33789C11.4849 6.33789 11.0694 6.75433 11.0694 7.26742V10.9855H7.35141C6.83738 10.9855 6.42188 11.4019 6.42188 11.915C6.42188 12.4281 6.83738 12.8445 7.35141 12.8445H11.0694V16.5625C11.0694 17.0756 11.4849 17.4921 11.999 17.4921C12.513 17.4921 12.9285 17.0756 12.9285 16.5625V12.8445H16.6465C17.1606 12.8445 17.5761 12.4281 17.5761 11.915C17.5761 11.4019 17.1606 10.9855 16.6465 10.9855Z",
    fill: "#334785"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlayer);
export default __webpack_public_path__ + "static/media/add-player.f166ad018d79cd8af2a290e15a294355.svg";
export { ForwardRef as ReactComponent };